import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectionTileComponent, FieldsetComponent } from '@woolworthsnz/form';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'fulfilment-method-selection',
	templateUrl: 'fulfilment-method.component.html',
	styleUrls: ['./fulfilment-method.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [FieldsetComponent, FormsModule, ReactiveFormsModule, SelectionTileComponent]
})
export class FulfilmentMethodComponent implements OnInit, OnDestroy {

	private destroyed$: Subject<boolean> = new Subject();
	@Input() controlName: string;

	@Input() formGroup: FormGroup;


	selected: string;

	ngOnInit(): void {
		this.formGroup.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe((val) => (this.selected = val[this.controlName]));
	}

	ngOnDestroy(): void {
		this.destroyed$.next(true);
    	this.destroyed$.complete();
	}
	getIconName(iconName: string, val: string): string {
		return val === this.selected ? `${iconName}-filled` : iconName;
	}
}
